import { filter, get } from 'lodash';
import { sizeOptionClassification } from '../../Constants/sizeOptionClassification';

export const getFirstItemClassificationIdentifier = (item) => item.itemclassifications?.[0]?.identifier || '';

export const hasItemClassification = (item, itemClassificationIdentifier) =>
  item.itemclassifications?.some(({ identifier }) => identifier === itemClassificationIdentifier);

export const getSelectedOptionFromConfiguration = (state, componentIdentifier) =>
  state.configurator.configuration.optionclassifications?.find(
    ({ identifier }) => identifier === componentIdentifier
  )?.selectedoptions?.[0];

export const getCurrentOptionFromConfiguration = (state, componentIdentifier, optionIdentifier) =>
  state.configurator.configuration.optionclassifications
    ?.find(({ identifier }) => identifier === componentIdentifier)
    ?.selectedoptions?.find(({ identifier }) => identifier === optionIdentifier) ||
  state.configurator.options.find(({ identifier }) => identifier === optionIdentifier);

export const getSelectedOptions = (configuration, componentIdentifier) =>
  configuration.optionclassifications?.find(({ identifier }) => identifier === componentIdentifier)
    ?.selectedoptions;

export const getChairNumber = (configuration) =>
  getSelectedOptions(configuration, 'chair_model')?.[0]?.amount || 0;

export const getChairNumberFromConfiguration = (state) =>
  getSelectedOptionFromConfiguration(state, 'chair_model')?.amount || 0;

export const getGroupPrice = (state, groupIdentifier) =>
  state.configurator.configuration.information.tableSet?.[groupIdentifier]?.totalPriceFormatted || 0;

export const getGroupObject = (state, groupIdentifier) =>
  state.configurator.configuration.information.tableSet?.[groupIdentifier] || {};

export const getTotalPriceForTableSet = (state) =>
  state.configurator.configuration.information.tableSet?.totalPriceFormatted || 0;

export const TABLE_SET_IDENTIFIER = 'table_set';
export const PAVILLON_IDENTIFIERS = ['siena_garden_pavillon', 'siena_garden_pavillon_3x6'];

export const isTableSet = (item) =>
  hasItemClassification(item, TABLE_SET_IDENTIFIER) || item.identifier === TABLE_SET_IDENTIFIER;

export const isPavillon = (item) => PAVILLON_IDENTIFIERS.includes(item.identifier);

export const shouldHidePavillonSizeOptionPrices = (state, optionClassificationIdentifier?) => {
  const item = state.configurator.configuration.item;
  const classificationIdentifier =
    optionClassificationIdentifier ?? state.configurator.selectedoptionclassification?.identifier;
  return isPavillon(item) && classificationIdentifier === sizeOptionClassification.identifier;
};

export const hasComponentGroups = (configuration) => configuration.information?.components?.length > 0;

export const tableTopHasFrame = (configuration) =>
  getSelectedOptions(configuration, 'table_top')?.[0]
    ?.attributes?.find(({ identifier }) => identifier === 'has_frame')
    ?.values?.find(({ value }) => value === true) || false;

const isTruthyValue = (value) => value === 1 || value === '1' || value === true || value === 'true';

export const isEmptyOptionSelected = (component) => {
  const firstSelectedOption = get(component?.components?.[0] || component, 'selectedoptions.0');

  const optionAttribute = filter(
    firstSelectedOption?.attributes,
    (attribute) => attribute.identifier === 'emptyoption'
  );
  const emptyAttributeValue = get(optionAttribute, '0.values.0.value', '0');
  return !firstSelectedOption || isTruthyValue(emptyAttributeValue);
};
